var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Falcon } from 'modules/macro';
import { useRotatingLabel } from '../hooks/useRotatingLabel';
import { Bars, Chevron, Container, Panel, Status, Steps, Trigger, TriggerIcon, TriggerLabel, TriggerMeta, } from '../styled';
export function AgenticPath(props) {
    const { label, meta, compact = false, boxed = false, defaultOpen = false, loading = false, loadingLabels, children } = props, rest = __rest(props, ["label", "meta", "compact", "boxed", "defaultOpen", "loading", "loadingLabels", "children"]);
    const loadingLabel = useRotatingLabel((loadingLabels === null || loadingLabels === void 0 ? void 0 : loadingLabels.length) ? loadingLabels : [label], loading);
    if (loading) {
        return (<Container {...rest}>
        <Status aria-live="polite">
          <Bars />
          <TriggerLabel $swapping={loadingLabel.swapping}>{loadingLabel.label}</TriggerLabel>
        </Status>
      </Container>);
    }
    return (<Container defaultOpen={defaultOpen} {...rest}>
      <Trigger>
        <TriggerIcon>
          <Falcon $size={11} icon="bolt" sourceConfig={{ family: 'classic', style: 'solid' }}/>
        </TriggerIcon>
        <TriggerLabel $swapping={false}>{label}</TriggerLabel>
        {meta && <TriggerMeta>· {meta}</TriggerMeta>}
        <Chevron>
          <Falcon $size={8} icon="chevron-right" sourceConfig={{ family: 'classic', style: 'solid' }}/>
        </Chevron>
      </Trigger>
      <Panel>
        <Steps $compact={compact} $boxed={boxed}>
          {children}
        </Steps>
      </Panel>
    </Container>);
}
